<template>
    <div class="all-order">
        <div class="all-order-content">
            <div style="padding: 20px;width: 1200px;" v-if="ruleForm.address">
                <el-descriptions title="" :column="2" border>
                    <el-descriptions-item label="单位名称">{{ queryData.exhibitorName }}</el-descriptions-item>
                    <el-descriptions-item label="展位号">{{ queryData.boothJson?JSON.parse(queryData.boothJson)[0].code:''}}</el-descriptions-item>
                    <el-descriptions-item label="联系地址">{{ ruleForm.address }}</el-descriptions-item>
                    <el-descriptions-item label="邮编">{{ ruleForm.postcode }}</el-descriptions-item>
                    <el-descriptions-item label="联系电话">{{ ruleForm.tel }}</el-descriptions-item>
                    <el-descriptions-item label="联系人">{{ ruleForm.contractName }}</el-descriptions-item>
                </el-descriptions>
                <el-table :data="list" style="width: 100%;margin-top: 20px;" row-key="id" :stripe="true"
                :tree-props="{ children: 'childrens', hasChildren: 'hasChildren' }"
                :header-cell-style="{ background: '#fafafa', color: '#333' }">
                <el-table-column prop="name" label="项目" width="400" align="center" />
                <el-table-column prop="back" label="备注" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.back }}
                    </template>
                </el-table-column>
            </el-table>
                <el-descriptions title="" :column="1" style="margin-top:20px">
                    <el-descriptions-item label="特殊要求">{{ruleForm.otherRemark }}</el-descriptions-item>

                </el-descriptions>
            </div>

            <div class="" v-else>
                <el-empty description="展商还未提交此内容">
                    <p>截止时间为：{{ timeValue }}，可提醒展商及时提交信息</p>
                </el-empty>
            </div>
        </div>
    </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
export default {
    name: "exhibition-info-catalogue",
    props:{
        timeValue:String
    },
    data () {

        return {
            catalogueInfoIsHave: false, // 会刊信息是否存在
            list: [
               

            ],

            ruleForm: {
                exhibitorName: '',
                boothJson: '',
                address: '',
                postcode: '',
                tel: '',
                fax: '',
                contractName: '',
                otherRemark: '',

            },
        
            loading: false,
            endDate: null,
            instructions: null,
            contactIllustrate: null,
          
        };
    },
    components: {
        // imgUpload,
    },
    computed: {
        ...mapGetters({
            exhibitor: "loginModule/getExhibitor",
        }),
        queryId () {
            return this.$route.query.id;
        },
        queryData () {
            let data = sessionStorage.getItem('sessData')
            return JSON.parse(data);
        },

    },
    created () {
        this.init();


    },
    mounted () {
     
    },
    methods: {
        ...mapActions({
            setManageSettingQ: 'hostSetModule/setManageSettingQ', //获取
            updateJournaladvertrecord: 'exhibitionModule/updateJournaladvertrecord', //修改
            journaladvertrecordList: 'exhibitionModule/journaladvertrecordList', //列表
        }),
        goDetail () {
            this.$router.push('/exhibition/index/order/detail-order');
        },
        async init () {
            let listDom=[]
            this.list=[]
            let res1 = await this.journaladvertrecordList(this.queryId)
            if (res1) {
                console.log(res1);
                this.ruleForm.address = res1.address
                this.ruleForm.postcode = res1.postcode
                this.ruleForm.tel = res1.tel
                this.ruleForm.fax = res1.fax
                this.ruleForm.contractName = res1.contractName
                this.ruleForm.otherRemark = res1.otherRemark
                if (res1.preBookJson) {
                    listDom  = JSON.parse(res1.preBookJson)
                    listDom.map(e=>{
                        if(e.nullable){
                            this.list.push(e)
                        }
                    })
                }
            }

        },





    },
};
</script>


<style lang="scss" scoped>
.all-order {
    min-width: 1000px;
    padding: 30px;
    min-height: 500px;

    &-content {
        background: #FFF;

        .goods {
            width: 18%;
            padding: 10% 0;
            display: inline-block;
            position: relative;
            margin: 0 3px;

            img {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                max-width: 100%;
                max-height: 100%;
                margin: auto;
            }
        }

        .goods-e {
            position: absolute;
            left: 100%;
            top: 30%;
            font-weight: bold;
        }

        .operation {
            color: #1890ff;
            cursor: pointer;
        }
    }
}
</style>